// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "1c7bfd4b4a30c280e7ae" + ".js";
};